import React from 'react';
import { Outlet } from 'react-router-dom';

import Footer from '../Footer';
import Header from '../Header';
import Main from '../Main';

import { StyledAppContainer } from './styled';

const Layout = () => (
  <StyledAppContainer>
    <Header />
    <Main>
      <Outlet />
    </Main>
    <Footer />
  </StyledAppContainer>
);

export default Layout;
